import '../../styles/skeleton.scss'


const SearchBoxSkeleton=()=>{
return (

    <div className="sb skeleton">
       <div className="sk one"></div>
       <div className="sk two"></div>
       <div className="sk three"></div>
    </div>

)
}

export default SearchBoxSkeleton